import React, { useMemo} from 'react';
import Card from '../../UI/Card';
import styled from 'styled-components';
import {CTAButton, fontSize} from '../../mixins';
import {useDispatch, useSelector} from 'react-redux';
import {currentUserInfo, locationByID} from '../../app/models/ormSelectors';
import {selectActiveUser, setShowDownloadModal} from '../dashboard/dashboardSlice';
import {selectUserInfo} from '../login/loginSlice';
import InfoPopup from '../dashboard/InfoPopup';
const SUPPORT_LINK = 'https://geozilla.com/contact/';

const StyledTitle = styled.b`
  margin: 8px 0 0;
  ${fontSize(18)};
  line-height: 20px;
  letter-spacing: -0.2px;
  color: #323232;
`
const StyledTxt = styled.p`
  ${fontSize(14)};
  line-height: 20px;
  color: #323232;
`

const StyledButton = styled.button`
 ${CTAButton};
 background: #FFFFFF;
 box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 16px 16px 16px rgba(97, 119, 122, 0.08);
 color: #33CCB7;
`

const TrackimoCard = () => {
    const dispatch = useDispatch();
    const userInfo = useSelector(currentUserInfo);
    const activeUser = useSelector(selectActiveUser);
    const geoByID = useSelector(locationByID);
    const accountOwnerID = useSelector(selectUserInfo).id;

    const {location} = geoByID(activeUser);
    const isDataPlan = userInfo.data_plan.dataplan_id !== 0;
    const isDeviceOwner = userInfo.parent_id === accountOwnerID;

    const onSupportClick = () => window.open(SUPPORT_LINK, '_blank').focus();
    const onSelectDataPlanClick = () => dispatch(setShowDownloadModal(true));


    const defineContent = () => {

        if (!isDataPlan) {
            if (isDeviceOwner) {
                return (
                    <>
                        <StyledTxt>Service Plan Activation is required to let the tracker transfer data</StyledTxt>
                        <StyledButton onClick={onSelectDataPlanClick} id='continue-button'>Select a Service Plan</StyledButton>
                    </>
                )
            }

            return (
                <>
                    <StyledTitle>Waiting for Activation</StyledTitle>
                    <StyledTxt>Device is not activated yet</StyledTxt>
                </>
            )
        } else {
            if (location) {
                return <InfoPopup isTrackimo={true}/>
            } else {
                if (isDeviceOwner) {
                    return (
                        <>
                            <StyledTitle>Setting up your device</StyledTitle>
                            <StyledTxt>Getting location may take several minutes. We’ll notify you when it’s done!</StyledTxt>
                            <StyledButton onClick={onSupportClick} id='continue-button'>Request Help</StyledButton>
                        </>
                    )
                }

                return (
                    <>
                        <StyledTitle>Waiting for Activation</StyledTitle>
                        <StyledTxt>Device is not activated yet</StyledTxt>
                    </>
                )
            }
        }
    };

    const contentMemoized = useMemo(defineContent, [location, isDataPlan, isDeviceOwner])


    return (
        <>
            {contentMemoized}
        </>
    );
}

export default TrackimoCard;